<script setup lang="ts">
import { DgrDialog } from '@stockmarkteam/donguri-ui';

interface Props {
  name: string;
}
defineProps<Props>();

// このコンポーネントはDgrDialogをラップしているだけなので、openの値をこのコンポーネント内で変更しない。
const open = defineModel<boolean>('open', { default: false });

type Emits = {
  confirm: [];
  cancel: [];
};
defineEmits<Emits>();
</script>

<template>
  <DgrDialog v-model:open="open" title="リストの削除">
    <template #description>
      <span class="c-text-regular--m"> {{ name }}のリストを削除しますか？</span>
    </template>

    <template #submit>
      <button
        class="c-btn c-btn--auto c-btn--negative"
        @click="$emit('confirm')"
      >
        削除
      </button>
    </template>
  </DgrDialog>
</template>
